import React, { createContext, useContext, useEffect, useState } from "react";
import english from "./translations/en.json";
import legalEnglish from "./translations/legal.en.json";

const LanguageContext = createContext(null);
const storageKey = "quicr-language";

function initialLanguage() {
  try {
    return window.localStorage.getItem(storageKey) === "en" ? "en" : "de";
  } catch (error) {
    console.warn("Language preference could not be read.", error);
    return "de";
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(initialLanguage);
  useEffect(() => {
    document.documentElement.lang = language;
    document.title =
      language === "de"
        ? "QUICR – Mehr Bewegung. Direkt vor Ort."
        : "QUICR – More movement. Right here.";
    try {
      window.localStorage.setItem(storageKey, language);
    } catch (error) {
      console.warn("Language preference could not be saved.", error);
    }
  }, [language]);
  const t = (text) =>
    language === "en" ? (english[text] ?? legalEnglish[text] ?? text) : text;
  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage requires LanguageProvider");
  return context;
}

export function LanguageSwitch() {
  const { language, setLanguage } = useLanguage();
  return (
    <div
      className="language-switch"
      role="group"
      aria-label={language === "de" ? "Sprache" : "Language"}
    >
      {["de", "en"].map((locale) => (
        <button
          key={locale}
          type="button"
          lang={locale}
          aria-label={locale === "de" ? "Deutsch" : "English"}
          aria-pressed={language === locale}
          onClick={() => setLanguage(locale)}
        >
          {locale.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
